<template>
  <div class="py-4">
    <v-card class="mx-auto" max-width="900" elevation="2">
      <v-toolbar color="#37474F" dark dense>
        <v-toolbar-title class="font-weight-bold">
          <v-icon left>mdi-cog</v-icon>
          스냅퀴즈 · 서버 설정
        </v-toolbar-title>
      </v-toolbar>

      <v-card-text class="pa-6">
        <div class="text-caption grey--text mb-4">
          버튼을 누르면 CMS 서버가 대상 스냅퀴즈 서버의 API 를 호출합니다.
        </div>

        <div class="d-flex flex-wrap" style="gap:12px;">
          <v-btn
            color="primary" depressed large
            :loading="loading === 'patch'"
            :disabled="loading !== null"
            @click="doGitPatch"
          >
            <v-icon left>mdi-git</v-icon>
            Git Patch (패치하기)
          </v-btn>

          <v-btn
            color="teal" dark depressed large
            :loading="loading === 'check'"
            :disabled="loading !== null"
            @click="doCheckServer"
          >
            <v-icon left>mdi-heart-pulse</v-icon>
            서버 응답 확인
          </v-btn>
        </div>

        <!-- 응답 -->
        <v-card outlined class="mt-6">
          <v-card-title class="text-subtitle-2 grey lighten-4 pa-2">
            <v-icon left small>mdi-import</v-icon>응답
            <v-spacer></v-spacer>
            <span v-if="resultOk !== null">
              <v-chip x-small :color="resultOk ? 'green' : 'red'" dark>{{ resultOk ? '성공' : '실패' }}</v-chip>
              <span class="ml-2 grey--text text-caption">{{ resultLabel }}</span>
            </span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <pre v-if="resultText" style="margin:0; padding:12px; background:#f5f5f5; font-size:12px; max-height:360px; overflow:auto">{{ resultText }}</pre>
            <div v-else class="pa-6 text-center grey--text text-caption">아직 호출하지 않았습니다.</div>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>

    <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="3000" top>
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'Quiz_Setting',

  data: () => ({
    loading: null,       // 'patch' | 'check' | null
    resultText: '',
    resultOk: null,
    resultLabel: '',
    snackbar: false,
    snackbarText: '',
    snackbarColor: 'success',
  }),

  methods: {
    ...mapActions(['SNAPQUIZ_GIT_PATCH', 'SNAPQUIZ_CHECK_SERVER']),

    async doGitPatch() {
      await this.run('patch', 'Git Patch', this.SNAPQUIZ_GIT_PATCH);
    },
    async doCheckServer() {
      await this.run('check', '서버 응답 확인', this.SNAPQUIZ_CHECK_SERVER);
    },

    async run(key, label, action) {
      this.loading = key;
      this.resultOk = null;
      this.resultText = '';
      const t0 = Date.now();
      try {
        const res = await action();
        this.resultOk = true;
        this.resultLabel = `${label} · ${Date.now() - t0}ms`;
        this.resultText = JSON.stringify(res, null, 2);
        this.showSnackbar(`${label} 완료`, 'success');
      } catch (err) {
        this.resultOk = false;
        this.resultLabel = `${label} · ${Date.now() - t0}ms`;
        this.resultText = typeof err === 'string' ? err : JSON.stringify(err, null, 2);
        this.showSnackbar(`${label} 실패`, 'error');
      } finally {
        this.loading = null;
      }
    },

    showSnackbar(text, color) {
      this.snackbarText = text;
      this.snackbarColor = color || 'success';
      this.snackbar = true;
    },
  },
};
</script>
